import { api } from '../api';

export const supportService = {
  async fetchSupports(params) {
    return api.get('supports', { params });
  },

  async fetchSupport(id) {
    return api.get('supports/' + id );
  },

  async createSupport(params) {
    return api.post('supports', params);
  },

  async replySupport(id, params) {
    return api.post('supports/' + id, { '_method': 'PUT', ...params });
  },
};